(function () {
  if (window.SenbederQuoteStore) return;

  var STORAGE_KEY = 'senbeder:procurement-list:v1';
  var CHANGE_EVENT = 'senbeder:quote-list-changed';
  var OPEN_EVENT = 'senbeder:quote-list-open';
  var QUOTE_MARKUP_MULTIPLIER = 1.3;
  var QUOTE_PRICING_VERSION = 'b2b-quote-30-v1';
  var memoryItems = [];

  function roundCurrency(value) {
    return Math.round((Math.max(0, Number(value) || 0) + Number.EPSILON) * 100) / 100;
  }

  function formatMoney(value) {
    return '$' + roundCurrency(value).toFixed(2);
  }

  function normalizeItem(item) {
    if (!item || item.id == null) return null;

    var incomingPrice = Math.max(0, Number(item.price) || 0);
    var hasBasePrice = item.basePrice !== '' && item.basePrice != null && Number.isFinite(Number(item.basePrice));
    var alreadyMarkedUp = item.quotePricingVersion === QUOTE_PRICING_VERSION;
    var basePrice = hasBasePrice
      ? Math.max(0, Number(item.basePrice) || 0)
      : (alreadyMarkedUp ? roundCurrency(incomingPrice / QUOTE_MARKUP_MULTIPLIER) : incomingPrice);
    var quotePrice = alreadyMarkedUp
      ? roundCurrency(incomingPrice)
      : roundCurrency(basePrice * QUOTE_MARKUP_MULTIPLIER);

    return {
      id: String(item.id),
      legacyProductId: String(item.legacyProductId || ''),
      title: String(item.title || 'Product'),
      xbd: String(item.xbd || item.sku || ''),
      desc: String(item.desc || item.description || ''),
      unit: String(item.unit || ''),
      moq: String(item.moq || ''),
      price: quotePrice,
      priceDisplay: formatMoney(quotePrice),
      basePrice: roundCurrency(basePrice),
      quotePricingVersion: QUOTE_PRICING_VERSION,
      qty: Math.max(1, Math.floor(Number(item.qty) || 1)),
      url: String(item.url || ''),
      image: String(item.image || ''),
      market: String(item.market || '')
    };
  }

  function readItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      memoryItems = parsed.map(normalizeItem).filter(Boolean);
      if (parsed.some(function (item) { return item && item.quotePricingVersion !== QUOTE_PRICING_VERSION; })) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryItems));
      }
      return memoryItems.slice();
    } catch (error) {
      return memoryItems.slice();
    }
  }

  function writeItems(items, source) {
    var normalized = items.map(normalizeItem).filter(Boolean);
    memoryItems = normalized;

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {}

    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
      detail: {
        items: normalized,
        source: source || 'unknown',
        count: normalized.reduce(function (total, item) { return total + item.qty; }, 0)
      }
    }));

    return normalized.slice();
  }

  function add(item, quantity, source) {
    var incoming = normalizeItem(Object.assign({}, item, { qty: quantity || item.qty || 1 }));
    if (!incoming) return readItems();

    var items = readItems();
    var matches = items.filter(function (entry) {
      return entry.id === incoming.id || (incoming.legacyProductId && entry.id === incoming.legacyProductId);
    });
    var existing = matches[0];

    if (existing) {
      existing.qty = matches.reduce(function (sum, entry) { return sum + entry.qty; }, incoming.qty);
      items = items.filter(function (entry) { return entry === existing || !matches.includes(entry); });
      Object.keys(incoming).forEach(function (key) {
        if (incoming[key] !== '' && incoming[key] != null && key !== 'qty') existing[key] = incoming[key];
      });
    } else {
      items.push(incoming);
    }

    return writeItems(items, source || 'add');
  }

  function remove(id, source) {
    return writeItems(readItems().filter(function (item) {
      return item.id !== String(id);
    }), source || 'remove');
  }

  function setQty(id, quantity, source) {
    var items = readItems();
    var item = items.find(function (entry) { return entry.id === String(id); });
    if (!item) return items;
    item.qty = Math.max(1, Math.floor(Number(quantity) || 1));
    return writeItems(items, source || 'setQty');
  }

  function clear(source) {
    return writeItems([], source || 'clear');
  }

  function replace(items, source) {
    return writeItems(Array.isArray(items) ? items : [], source || 'replace');
  }

  function count() {
    return readItems().reduce(function (total, item) { return total + item.qty; }, 0);
  }

  function total() {
    return readItems().reduce(function (sum, item) { return sum + item.price * item.qty; }, 0);
  }

  function open(source) {
    window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { source: source || 'unknown' } }));
  }

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    var items = readItems();
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
      detail: {
        items: items,
        source: 'storage',
        count: items.reduce(function (totalCount, item) { return totalCount + item.qty; }, 0)
      }
    }));
  });

  window.SenbederQuoteStore = {
    key: STORAGE_KEY,
    changeEvent: CHANGE_EVENT,
    openEvent: OPEN_EVENT,
    getItems: readItems,
    add: add,
    remove: remove,
    setQty: setQty,
    clear: clear,
    replace: replace,
    count: count,
    total: total,
    open: open
  };
})();
